import React from 'react';

import useAutoImageHeight from '../../utils/hooks/useAutoImageHeight';
import { PACKAGE_IMAGE_ASPECT_RATIOS } from '../../utils/package';

const OfferingPackageCardSkeleton = () => {
  const imageSkeletonProps = useAutoImageHeight(
    PACKAGE_IMAGE_ASPECT_RATIOS.HEIGHT_TO_WIDTH,
  );

  return (
    <div className="flex animate-pulse flex-col items-start justify-start border-b border-leland-gray-stroke py-6 md:border-none md:py-0">
      <div className="flex w-full space-x-3 md:flex-col md:space-x-0 md:space-y-4">
        <div
          className="w-32 shrink-0 rounded-md bg-leland-gray-hover md:w-full"
          {...imageSkeletonProps}
        />
        <div className="flex w-full flex-col space-y-4 md:space-y-2">
          <div className="h-8 w-full rounded-md bg-leland-gray-hover md:w-3/4" />
          <div className="h-6 w-3/5 rounded-md bg-leland-gray-hover md:w-2/5" />
        </div>
      </div>
      <div className="mt-4 h-8 w-full rounded-md bg-leland-gray-hover" />
    </div>
  );
};

export default OfferingPackageCardSkeleton;
